import { ButtonStyled } from "../OfficeDetail/style";
import { ReservationConfirmationCard } from "../ReservationConfirmationCard";
import { WrapperBack } from "../Calendar/style";
import React from "reactn";

const ConfirmReservation = ({
	onBack = () => {},
	onConfirm = () => {},
	office,
	line,
	blockSelected = {},
	isLoading,
	style,
}) => {
	const { 0: date = {} } = blockSelected.blocks || [];
	return (
		<div style={style ? style : {}}>
			<ReservationConfirmationCard
				officeName={office && office.name}
				lineName={line && line.name}
				selectedDate={date}
				desktop
			/>
			<WrapperBack>
				<ButtonStyled typeForStyled="backgroundless" onClick={onBack}>
					Atrás
				</ButtonStyled>
				<ButtonStyled
					typeForStyled="primary"
					onClick={onConfirm}
					disabled={isLoading}
				>
					Confirmar reserva
				</ButtonStyled>
			</WrapperBack>
		</div>
	);
};

export default ConfirmReservation;
